import { useEffect, useState } from 'react'
import { useLanguageManager } from './useLanguageManager'
import { resolveAuthLanguage } from '../utils/authLanguage'

export function useAuthLanguage() {
  // Resolve once before rendering, so mount effects cannot overwrite a URL language.
  const [initialLanguage] = useState(() => resolveAuthLanguage({
    search: window.location.search,
    storedLanguage: localStorage.getItem('i18nextLng'),
    browserLanguage: navigator.language,
  }))
  const languageManager = useLanguageManager(initialLanguage)
  const { currentLanguage } = languageManager

  useEffect(() => {
    const url = new URL(window.location.href)
    url.searchParams.set('lang', currentLanguage)
    window.history.replaceState(window.history.state, '', url)
  }, [currentLanguage])

  return languageManager
}
